import { axios, API } from "@/imports-files/common/common";
import {SendRequest} from '@/services/common/send-request';

export class EmailTemplatesService extends SendRequest
{
    async getSystemEmailTemplateData(params)
    {
        const url = API.email_templates.SYSTEM_TEMPLATE_LIST;
        try {
             const result = await axios.get( url,
              {
                params: params,
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async getCustomEmailTemplateData(params)
    {
        const url = API.email_templates.CUSTOM_TEMPLATE_LIST;
        try {
             const result = await axios.get( url,
              {
                params: params,
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async deleteCustomEmailTemplateData(params)
    {
        const url = API.email_templates.DELETE_CUSTOM_TEMPLATE;
        try {
             const result = await axios.delete( url,
              {
                params: params,
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async getSystemPurposeList()
    { 
        const url = API.email_templates.CLIENT_PURPOSE_LIST;
        try {
             const result = await axios.get( url,
              {
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async getPurposesList()
    {
        const url = API.email_templates.CUSTOM_TEMPLATE_LIST;
          try {
              const result = await axios.get( url,
                {
                    headers: this.customHeaderJSON()
                },
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
              return result;
            } catch (error) {
              return error;
            }
    }

    async getMembersList(params)
    {
        const url = API.email_templates.CLIENT_MEMBER_LIST;
          try {
              const result = await axios.get( url,
                {   
                    params: params,
                    headers: this.customHeaderJSON()
                },
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
              return result;
            } catch (error) {
              return error;
            }
    }

    async saveEmailTemplate(params, job_id)
    {
        const url =  API.client.jobs.SAVE_EMAIL_TEMPLATE.replace('$job_id', job_id);
        try 
        {
            const result = await axios.post(url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }
}